<template>
    <div id="app">
        <phone-page v-if="isPhone"></phone-page>
        <pad-page v-else-if="isPad"></pad-page>
        <pc-page v-else></pc-page>
    </div>
</template>

<script>
    import PcPage from './components/PcPage'
    import PadPage from './components/PadPage'
    import PhonePage from './components/PhonePage'

    import MobileDetect from 'mobile-detect';

    export default {
        name: 'App',
        components: {
            PcPage,
            PadPage,
            PhonePage
        },
        data() {
            return {
                isPhone: false,
                isPad: false,
            }
        },
        beforeMount() {
            this.getDeviceType();
        },
        mounted() {
            window.addEventListener("resize", this.resize)
        },
        methods: {
            getDeviceType() {
                const md = new MobileDetect(window.navigator.userAgent)
                if (md.mobile()) {
                    this.isPhone = true;
                    this.isPad = false;
                    let fontsize = window.screen.availWidth / 375 * 100;
                    document.documentElement.style.fontSize = fontsize + "px";
                } else if (md.tablet()) {
                    this.isPhone = false;
                    this.isPad = true;
                } else {
                    this.isPhone = false;
                    this.isPad = false;
                }
                console.log(this.isPhone)
                console.log(this.isPad)
            }
        },
        resize() {
            this.getDeviceType();
        }
    }
</script>

<style>
    @font-face {
        font-family: 'sye';
        src: url('@/font/SourceHanSerifCN-Regular.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'syr';
        src: url('@/font/SourceHanSerifCN-ExtraLight.woff2') format('woff2');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    html, body {
        padding: 0;
        margin: 0;
        background-color: #000;
        width: 100%;
        font-size: 100px;
        font-family: 'syr', 'sye', '思源宋体', PingFang SC, -apple-system, Hiragino Sans GB, STHeiti, Microsoft Yahei, system-ui, Avenir, Segoe UI, Rototo, Helvetica, Arial, sans-serif;
    }

    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        width: 100%;
        font-size: 0.24rem;
    }
    .mail{
        text-decoration: underline;
        color: #FFF;
        font-weight: 600;
    }
    .mail-pc, 
    .mail-pad{
        font-size: 0.26rem;
    }
    .mail-pc-english, 
    .mail-pad-english{
        font-size: 0.24rem;
    }
    .mail-phone{
        font-size: 0.12rem;
    }
    .mail-phone-english{
        font-size: 0.12rem;
    }

</style>
